import { validateAwsAccounts } from "../../../../utils/validate";
import { useTranslate } from "../../../../customHooks";
import { Tooltip } from "@panwds/react-ui";
import { InfoIcon } from "@panwds/icons";
import { Input } from "@panwds/react-form";

const Index = () => {
    const translate = useTranslate();

    return (
        <div className="formLayout">
            <Input
                name="AllowListAccounts"
                label={translate(`resources.firewallsV2.endpointManagement.allowListedAccounts`)}
                dataMetrics="cloudngfw-firewall-create-allowlist-accounts"
                register={{
                    required: false, validate: validateAwsAccounts
                }}
                description={translate(`resources.firewallsV2.allowListedAccountsMessage`)}
                placeholder="Enter one or more AWS accounts and use comma to separate them (e.g account1, account2 )"
                tooltip={translate(`resources.firewallsV2.endpointManagement.allowListedAccountsTooltip`)}
            />
        </div>
    );
};

export default Index;
